import { FormSection, FormRow, BigFormRow } from 'framework/ui/layout';
import { TextArea, DateInput, RadioButtonGroup } from 'framework/form';
import { OneStopAttachmentUploaderInput } from 'domain/shared/oneStop';
import useFeatureToggle from 'framework/featureToggle';
import { Features } from 'infrastructure/featureToggle';
import { VendorDropdown } from 'domain/shared/vendor';
import usePurchaseRequestService from './usePurchaseRequestService';
import { OFFICE_NAMES, OfficeDropdown } from 'domain/shared/employee';
import { OneStopPageLayout } from 'domain/shared/oneStop';
import { ONE_STOP_PATH, OneStopCreateForm } from 'domain/shared/oneStop';

type OneStopPurchaseRequestProps = {
  openModal: (message: string) => void;
  requestId?: string;
};

const paymentConfirmationOptions = [
  { value: 'YES', label: 'Yes' },
  { value: 'NO', label: 'No' },
];

const OneStopPurchaseRequest = ({ openModal, requestId = 'PURCHASE_REQUEST' }: OneStopPurchaseRequestProps) => {
  const { createPurchaseRequest, getValidationSchema } = usePurchaseRequestService();
  const { isFeatureEnabled } = useFeatureToggle();
  const showPurchaseInvoice = isFeatureEnabled(Features.PURCHASE_REQUEST_PURCHASE_INVOICE);

  return (
    <OneStopCreateForm
      requestId={requestId}
      submitFormFunc={createPurchaseRequest}
      afterSubmit={{
        redirect: ONE_STOP_PATH,
        execute: response => {
          openModal('Purchase request has been successfully submitted!');
        },
      }}
      getValidationSchemaFunc={getValidationSchema}
      initialData={{
        isPaymentConfirmNeeded: 'NO',
      }}
    >
      <OneStopPageLayout>
        <FormSection title="">
          <FormRow>
            <OfficeDropdown
              source="officeLocation"
              label="Office"
              placeholder="Select office"
              mapResults={(office: any) => ({
                value: OFFICE_NAMES[office.name] || office.name,
                label: OFFICE_NAMES[office.name] || office.name,
              })}
            />
            <VendorDropdown source="vendorId" label="Vendor" placeholder="Select vendor" />
            <DateInput
              source="requiredDeliveryDate"
              label="Required delivery date"
              placeholder="Select delivery date"
            />
          </FormRow>

          <BigFormRow>
            <TextArea
              source="purchaseDescription"
              label="Purchase description"
              placeholder="Indicate what should be purchased, quantity and price"
              tooltip="Indicate what should be purchased, quantity and price"
              rows={4}
            />
          </BigFormRow>

          <BigFormRow>
            <TextArea
              source="purchasePurpose"
              label="Purchase purpose"
              placeholder="Enter purpose of purchase"
              rows={3}
            />
          </BigFormRow>

          <FormRow>
            <RadioButtonGroup
              source="isPaymentConfirmNeeded"
              label="Do you need payment confirmation document?"
              options={paymentConfirmationOptions}
            />
          </FormRow>
          {showPurchaseInvoice ? (
            <BigFormRow>
              <OneStopAttachmentUploaderInput
                source="purchaseInvoice"
                label="Purchase invoice"
                tooltip="Please attach the invoice. It may be provided later if unavailable now."
                maxElements={1}
              />
            </BigFormRow>
          ) : null}
        </FormSection>
      </OneStopPageLayout>
    </OneStopCreateForm>
  );
};

export default OneStopPurchaseRequest;
